import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { TRADES_QUERY_KEY } from "./useTrades";

type RecordFillBody = components["schemas"]["RecordFillBody"];
type TradeResponse = components["schemas"]["TradeResponse"];

export type RecordFillVariables = {
  tradeId: string;
  body: RecordFillBody;
};

export function useRecordFill() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<TradeResponse, Error, RecordFillVariables>({
    mutationFn: async ({ tradeId, body }) => {
      const { data, error } = await client.POST("/api/trades/{trade_id}/fills", {
        params: { path: { trade_id: tradeId } },
        body,
      });
      if (error !== undefined) {
        throw new Error(`Failed to record fill on trade ${tradeId}`);
      }
      return data;
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: TRADES_QUERY_KEY });
      void queryClient.invalidateQueries({
        queryKey: [...TRADES_QUERY_KEY, "detail", variables.tradeId],
      });
    },
  });
}
